import React from 'react';
import { MainLayout } from '../layouts/MainLayout';
import { Card } from '../components/ui/Card';
import { Select } from '../components/ui/Select';
import { Badge } from '../components/ui/Badge';
import { Network, Router, Wifi, Server } from 'lucide-react';
interface NetworkOverviewProps {
  onLogout: () => void;
}
export function NetworkOverview({
  onLogout
}: NetworkOverviewProps) {
  return <MainLayout title="Netzwerkübersichten" onLogout={onLogout} data-id="element-470">
      <div className="mb-6 w-full md:w-64" data-id="element-471">
        <Select options={[{
        value: '1',
        label: 'Müller GmbH - Hauptstandort'
      }, {
        value: '2',
        label: 'Schmidt KG - Filiale Nord'
      }]} data-id="element-472" />
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-473">
        {/* Network Info */}
        <div className="space-y-6" data-id="element-474">
          <Card title="Netzwerk Details" data-id="element-475">
            <div className="space-y-4" data-id="element-476">
              <div data-id="element-477">
                <h4 className="text-xs font-semibold text-slate-500 uppercase mb-2" data-id="element-478">
                  WAN / Internet
                </h4>
                <div className="flex items-center justify-between p-3 bg-slate-50 rounded-lg" data-id="element-479">
                  <div className="flex items-center gap-2" data-id="element-480">
                    <Network className="h-4 w-4 text-slate-500" data-id="element-481" />
                    <span className="text-sm font-medium" data-id="element-482">
                      Telekom Glasfaser
                    </span>
                  </div>
                  <Badge variant="success" data-id="element-483">Online</Badge>
                </div>
              </div>

              <div data-id="element-484">
                <h4 className="text-xs font-semibold text-slate-500 uppercase mb-2" data-id="element-485">
                  Subnetze
                </h4>
                <div className="space-y-2" data-id="element-486">
                  <div className="flex justify-between text-sm p-2 border border-slate-100 rounded" data-id="element-487">
                    <span data-id="element-488">Management</span>
                    <span className="font-mono text-slate-600" data-id="element-489">
                      192.168.1.0/24
                    </span>
                  </div>
                  <div className="flex justify-between text-sm p-2 border border-slate-100 rounded" data-id="element-490">
                    <span data-id="element-491">Clients</span>
                    <span className="font-mono text-slate-600" data-id="element-492">
                      192.168.10.0/24
                    </span>
                  </div>
                  <div className="flex justify-between text-sm p-2 border border-slate-100 rounded" data-id="element-493">
                    <span data-id="element-494">Gast-WLAN</span>
                    <span className="font-mono text-slate-600" data-id="element-495">
                      172.16.0.0/24
                    </span>
                  </div>
                </div>
              </div>

              <div data-id="element-496">
                <h4 className="text-xs font-semibold text-slate-500 uppercase mb-2" data-id="element-497">
                  VLANs
                </h4>
                <div className="flex gap-2" data-id="element-498">
                  <Badge variant="outline" data-id="element-499">VLAN 1 (Mgmt)</Badge>
                  <Badge variant="outline" data-id="element-500">VLAN 10 (Office)</Badge>
                  <Badge variant="outline" data-id="element-501">VLAN 20 (VoIP)</Badge>
                </div>
              </div>
            </div>
          </Card>
        </div>

        {/* Visual Diagram Placeholder */}
        <div className="lg:col-span-2" data-id="element-502">
          <Card title="Topologie" className="h-full min-h-[400px] flex items-center justify-center bg-slate-50" data-id="element-503">
            <div className="text-center" data-id="element-504">
              <div className="relative w-full max-w-lg mx-auto p-8 border-2 border-dashed border-slate-300 rounded-xl" data-id="element-505">
                {/* Simple CSS Diagram */}
                <div className="flex flex-col items-center gap-8" data-id="element-506">
                  <div className="p-4 bg-white shadow-sm border border-slate-200 rounded-lg flex flex-col items-center" data-id="element-507">
                    <Router className="h-8 w-8 text-red-500 mb-2" data-id="element-508" />
                    <span className="text-xs font-bold" data-id="element-509">
                      Firewall (Gateway)
                    </span>
                    <span className="text-[10px] text-slate-500" data-id="element-510">
                      192.168.1.1
                    </span>
                  </div>

                  <div className="h-8 w-0.5 bg-slate-300" data-id="element-511"></div>

                  <div className="p-4 bg-white shadow-sm border border-slate-200 rounded-lg flex flex-col items-center" data-id="element-512">
                    <Server className="h-8 w-8 text-blue-500 mb-2" data-id="element-513" />
                    <span className="text-xs font-bold" data-id="element-514">Core Switch</span>
                    <span className="text-[10px] text-slate-500" data-id="element-515">
                      192.168.1.2
                    </span>
                  </div>

                  <div className="relative w-full h-8" data-id="element-516">
                    <div className="absolute left-1/2 top-0 bottom-0 w-0.5 bg-slate-300 -translate-x-1/2" data-id="element-517"></div>
                    <div className="absolute top-1/2 left-1/4 right-1/4 h-0.5 bg-slate-300" data-id="element-518"></div>
                    <div className="absolute top-1/2 left-1/4 h-4 w-0.5 bg-slate-300" data-id="element-519"></div>
                    <div className="absolute top-1/2 right-1/4 h-4 w-0.5 bg-slate-300" data-id="element-520"></div>
                  </div>

                  <div className="flex gap-12" data-id="element-521">
                    <div className="p-3 bg-white shadow-sm border border-slate-200 rounded-lg flex flex-col items-center" data-id="element-522">
                      <Wifi className="h-6 w-6 text-teal-500 mb-1" data-id="element-523" />
                      <span className="text-xs font-bold" data-id="element-524">AP Office</span>
                    </div>
                    <div className="p-3 bg-white shadow-sm border border-slate-200 rounded-lg flex flex-col items-center" data-id="element-525">
                      <Wifi className="h-6 w-6 text-teal-500 mb-1" data-id="element-526" />
                      <span className="text-xs font-bold" data-id="element-527">AP Lager</span>
                    </div>
                  </div>
                </div>
              </div>
              <p className="text-sm text-slate-500 mt-4" data-id="element-528">
                Interaktive Netzwerkkarte (Read-Only)
              </p>
            </div>
          </Card>
        </div>
      </div>
    </MainLayout>;
}